// imports section Start
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Checkbox,
  Typography,
  Collapse,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import Navbar from "../../../components/common/Navbar";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import confirmed_re from "../../../assets/images/confirmed_re.svg";
import SnackbarMessage from "../../../components/common/SnackbarMessage";
import { clearCashierCart } from "../../../store/ReduxCashierCartReducer";
// import { ORDER_API_06 } from "../../api/ApiModel";
// import { externalgetApi } from "../../services/external/externalApis";
import { resetCards } from "../../../store/ReduxCardSlice";
import { clearCheque } from "../../../store/ReduxChequeSlice";
import { resetVouchers } from "../../../store/ReduxVoucherSlice";
import { clearSlips } from "../../../store/ReduxSlipSlice";
import { encodeUrl } from "../../../utils/common/UrlUtils";
import { getCeNoteTypeFromPayload } from "../../../utils/cashier/cenoteReturnTypeStorage";
import CashierHeaderMobile from "../../../components/mobile/cashier/cashier/CashierHeaderMobile";
// imports section End

function OrderSuccessMobile() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const dispatch = useDispatch();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [billDetails, setBillDetails] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { orderPayload, orderCode } = location.state || {};
  const [selectedPrinter, setSelectedPrinter] = useState("default");
  const source = location.state?.source; // Get the source from the state passed during navigation
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  // const orderCode = orderPayload.orderCode;
  // Hooks end

  // Handlers start
  let displayMessage = "";

  // Conditionally set the display message based on the source
  if (source === "CashierSummery") {
    displayMessage = "Order Successfully Placed!"; // Message for CashierSummery
  } else if (source === "CashierPayment") {
    displayMessage = "Order Successfully Updated! (Payment Done)"; // Message for CashierPayment
  } else {
    displayMessage = "Order Successfully Updated! (Payment Done)"; // Default message
  }
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleClearCart = () => {
    dispatch(clearCashierCart());
    dispatch(resetCards());
    dispatch(clearCheque());
    dispatch(resetVouchers());
    dispatch(clearSlips());
    // setPlacedOrderDetails([]);
    navigate("/CashierMobile");
  };

  const handlePrintBill = () => {
    if (!orderCode) return;

    const encodedOrderCode = encodeUrl(orderCode);
    const colorMode = theme.palette.mode; // Assuming `mode` holds the current theme mode (light or dark)
    const qpdata = encodeUrl(`${COMPCODE}|${LOCCODE}|${RESTCODE}`);
    const ceNoteType = getCeNoteTypeFromPayload(orderPayload);
    const cenoteTypeParam = ceNoteType
      ? `&cenoteType=${encodeUrl(String(ceNoteType))}`
      : "";
    const receiptUrl =
      selectedPrinter === "a4"
        ? `/CashReceiptA4?orderCode=${encodedOrderCode}&source=${source}&colorMode=${colorMode}&data=${qpdata}${cenoteTypeParam}`
        : `/CashReceipt?orderCode=${encodedOrderCode}&source=${source}&colorMode=${colorMode}&data=${qpdata}${cenoteTypeParam}`;

    window.open(receiptUrl, "_blank");
  };

  const handlePrintKOT = () => {
    if (orderCode) {
      const receiptUrl = `/PrintKOT?orderCode=${orderCode}`;
      window.open(receiptUrl, "_blank");
    }
  };

  // Handlers end

  return (
    <div>
      <CashierHeaderMobile />

      <Box sx={styles.os_box_container}>
        <Grid container justifyContent={"center"} display={"flex"}>
          <Stack
            direction={"column"}
            spacing={1}
            sx={styles.order_success_container}
          >
            <Box textAlign={"center"}>
              <Typography variant="h1">Order Number</Typography>
              <Typography variant="h2" sx={styles.order_success_order_nmb}>
                {orderCode}
              </Typography>
              <Typography variant="body2" color={"green"}>
                {displayMessage}
              </Typography>
            </Box>
            <Box
              component="img"
              src={confirmed_re}
              alt="Point of Order System"
              sx={styles.os_img_confirm}
            />
            <Box>
              <FormControl>
                <RadioGroup
                  value={selectedPrinter}
                  onChange={(e) => setSelectedPrinter(e.target.value)}
                  aria-labelledby="printer-selection"
                >
                  <FormControlLabel
                    value="a4"
                    control={<Radio />}
                    label="A4 Paper"
                  />
                  <FormControlLabel
                    value="default"
                    control={<Radio />}
                    label="Default Printer for POS Bill"
                  />
                </RadioGroup>
              </FormControl>
            </Box>

            <Button
              variant="contained"
              size="large"
              sx={styles.btn_primary}
              onClick={handlePrintBill}
            >
              Print Bill
            </Button>

            <Grid container gap={1} borderTop={1} pt={2}>
              {/* <Button
                variant="contained"
                size="large"
                sx={styles.btn_primary_2}
                onClick={handlePrintKOT}
              >
                Print KOT
              </Button> */}
              {/* <Button variant="contained" sx={styles.btn_primary}>
                Rate Order
              </Button> */}
              {/* <Button variant="contained" size="large" sx={styles.btn_primary}>
                New Order
              </Button> */}

              <Button
                variant="contained"
                onClick={handleClearCart}
                fullWidth
                size="large"
                sx={styles.btn_primary}
              >
                New Order
              </Button>
            </Grid>
          </Stack>
        </Grid>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </div>
  );
}

export default OrderSuccessMobile;
